import moment from "moment";

export const ACCRUAL_DATE_DISPLAY_FORMAT = "DD/MM/YYYY";
export const ACCRUAL_DATE_MASK = "99/99/9999";
export const ACCRUAL_DATE_SLOT_CHAR = "_";

export const isEmptyDateValue = (value?: string | null) => {
  if (!value) return true;

  return (
    value
      .replace(new RegExp(ACCRUAL_DATE_SLOT_CHAR, "g"), "")
      .replace(/\//g, "").length === 0
  );
};

export const isoToDisplayDate = (isoDate: string): string =>
  isoDate ? moment(isoDate).format(ACCRUAL_DATE_DISPLAY_FORMAT) : "";

export const displayToIsoDate = (displayDate: string): string =>
  moment(displayDate, ACCRUAL_DATE_DISPLAY_FORMAT).format("YYYY-MM-DD");
